import httpClient from "@/API/HttpClient";
import AuthClient from '@/API/AuthClient'

// Login
const login = (mobile,password) => AuthClient.post(`Accounts/authenticate`, {mobile,password});
// Register
const register = (firstName,lastName,mobile, password,confirmPassword,acceptTerms) => AuthClient.post(`Accounts/register`, {firstName,lastName,mobile, password,confirmPassword,acceptTerms});
// Forgot Password
const forgotpassword = (mobile) => AuthClient.post(`Accounts/forgot-password`, {mobile});
// Reset Password
const resetpassword = (token,password,confirmPassword) => AuthClient.post(`Accounts/reset-password`, {token,password,confirmPassword});
// Get Store
const getStore = () => httpClient.get(`Store`);
//Insert Or Edit
const EditStore = (EditStore) => httpClient.post('Stores/editstore', EditStore)
const UploadImage = (Type,Id,Image) => httpClient.post('Stores/uploadimage', Image,{
    headers: {
        'Content-Type': 'multipart/form-data',
        Type:Type,
        Id:Id
    }
  });
const DeleteImage = (Type,Id,Image) => httpClient.post(`Stores/deleteimage`,Image,{
  headers: {
      'Content-Type': 'multipart/form-data',
      Type:Type,
      Id:Id
  }
});

const GetStoreBySlug = (slug) => httpClient.get(`Store/${slug}`);
const getAnnouncement = (slug, pageNumber = 1, pageSize = 2, includeCount = false, searchTerm = null) => {
  return httpClient.get(`Announcement/${slug}`, {
    params: {
      pageNumber: pageNumber,
      pageSize: pageSize,
      includeCount: includeCount,
      searchTerm: searchTerm 
    }
  });
};

const DeleteAnnouncement = (slug,deletedid) => httpClient.delete(`deleteannouncement/${slug}?deletedid=${deletedid}`);
const getAnnouncementById = (id) => httpClient.get(`/ann/${id}`)
//const CreateAnnouncement = (slug,model) => httpClient.post(`createannouncement/${slug}`,model);
const CreateAnnouncement = (slug, model) => {
  return httpClient.post(`createannouncement/${slug}`, model, {
      headers: {
          'Content-Type': 'application/json'
      }
  });
};
const UpdateAnnouncement = (slug,model) => httpClient.put(`updateannouncement/${slug}`,model);
const getMenu = (id) => httpClient.get(`/Menu/${id}`)
const getMainMenu = () => httpClient.get(`/mainmenu`)
const getCategory = (id) => httpClient.get(`/cat/${id}`)
const getCategoryItems = (id, pageNumber = 1, pageSize = 2, includeCount = false, searchTerm = null) => {
  return httpClient.get(`catitems/${id}`, {
    params: {
      pageNumber: pageNumber,
      pageSize: pageSize,
      includeCount: includeCount,
      searchTerm: searchTerm 
    }
  });
};
//const getCategoryItems = (id) => httpClient.get(`/catitems/${id}`)
const GetLanguages = () => httpClient.get(`/language`)
const getMenuItem = (id) => httpClient.get(`/MenuItem/${id}`)
const CreateMenuItem = (slug,model) => httpClient.post(`createmenuitem/${slug}`,model);
const UpdateMenuItem = (slug,model) => httpClient.put(`updatemenuitem/${slug}`,model);
const DeleteMenuItem = (slug,deletedid) => httpClient.delete(`deletemenuitem/${slug}?deletedid=${deletedid}`);
const CreateMenu = (slug,model) => httpClient.post(`createmenu/${slug}`,model);
const UpdateMenu = (slug,model) => httpClient.put(`updatemenu/${slug}`,model);
const DeleteMenu = (slug,deletedid) => httpClient.delete(`deletemenu/${slug}?deletedid=${deletedid}`);
const getAllCity = () => httpClient.get(`AllCity`);
const getCountries = () => httpClient.get(`Country`);
const getStatus = () => httpClient.get(`Status`);
const getCitis = (countryid) => httpClient.get(`City/${countryid}`);
const CreateCategory = (slug,model) => httpClient.post(`createmenucategory/${slug}`,model);
const UpdateCategory= (slug,model) => httpClient.put(`updatemenucategory/${slug}`,model);
const DeleteCategory = (slug,deletedid) => httpClient.delete(`deletemenucategory/${slug}?deletedid=${deletedid}`);
export {
    login,
    register,
    forgotpassword,
    resetpassword,
    getStore,
    EditStore,
    UploadImage,
    DeleteImage,
    CreateMenu,
    UpdateMenu,
    DeleteMenu,
    GetStoreBySlug,
    getMenu,
    getMainMenu,
    CreateCategory,
    UpdateCategory,
    DeleteCategory,
    getCategory,
    GetLanguages,
    CreateMenuItem,
    UpdateMenuItem,
    DeleteMenuItem,
    getMenuItem,
    getCategoryItems,
    getCountries,
    getCitis,
    getAllCity,
    getStatus,
    getAnnouncement,
    DeleteAnnouncement,
    CreateAnnouncement,
    UpdateAnnouncement,
    getAnnouncementById
 }
